import { useAccessibility } from '../contexts/AccessibilityContext'

export default function AccessibilityToggle() {
  const { starfieldEnabled, toggleStarfield } = useAccessibility()

  return (
    <button
      onClick={toggleStarfield}
      className="flex items-center space-x-2 px-3 py-1.5 rounded-lg text-xs transition-all duration-200"
      style={{
        background: starfieldEnabled
          ? 'rgba(96, 165, 250, 0.15)'
          : 'rgba(100, 116, 139, 0.15)',
        border: `1px solid ${starfieldEnabled ? 'rgba(96, 165, 250, 0.3)' : 'rgba(100, 116, 139, 0.3)'}`,
        color: starfieldEnabled ? '#60a5fa' : 'rgba(148, 163, 184, 0.8)',
      }}
      title={starfieldEnabled ? 'Disable starfield animation' : 'Enable starfield animation'}
    >
      <i className={`fa-solid fa-${starfieldEnabled ? 'stars' : 'star'}`} />
      <span className="hidden sm:inline">Stars</span>
      <span
        className="w-8 h-4 rounded-full relative transition-colors"
        style={{
          background: starfieldEnabled
            ? 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)'
            : 'rgba(100, 116, 139, 0.3)',
        }}
      >
        <span
          className="absolute top-0.5 w-3 h-3 rounded-full transition-transform"
          style={{
            background: starfieldEnabled ? '#fff' : 'rgba(148, 163, 184, 0.8)',
            left: starfieldEnabled ? '18px' : '2px',
          }}
        />
      </span>
    </button>
  )
}
